import React from 'react';

interface PaginationProps {
  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  totalPages: number;
  isMobile?: boolean;
}

const Pagination: React.FC<PaginationProps> = ({
  page,
  setPage,
  totalPages,
  isMobile = false,
}) => {
  const handleNextPage = () => {
    setPage(page + 1);
  };

  const handlePreviousPage = () => {
    setPage(page - 1);
  };

  const handleFirstPage = () => {
    setPage(0);
  };

  const handleLastPage = () => {
    setPage(totalPages - 1);
  };

  const buttonBaseClasses = isMobile
    ? 'border-none rounded-[5px] text-gray-300 hover:cursor-pointer px-2 py-1 disabled:cursor-not-allowed disabled:opacity-50 !text-sm'
    : 'border-none rounded-[5px] text-gray-300 hover:cursor-pointer px-3 py-1 disabled:cursor-not-allowed disabled:opacity-50';

  const containerClasses = isMobile
    ? 'flex h-[32px] justify-center relative bg-[#FCCB164D] p-2 rounded-lg items-center'
    : 'flex md:h-[32px] justify-center relative bg-[#FCCB164D] p-2 rounded-lg md:rounded-b-lg md:rounded-t-none items-center';

  const textClasses = isMobile
    ? 'text-[#FFFFFF99] mx-4 !text-sm'
    : 'text-[#FFFFFF99] mx-10';

  return (
    <div className={containerClasses}>
      <button
        onClick={handleFirstPage}
        disabled={page === 0}
        className={buttonBaseClasses}
      >
        {'<<'}
      </button>
      <button
        onClick={handlePreviousPage}
        disabled={page === 0}
        className={buttonBaseClasses}
      >
        {'<'}
      </button>
      <strong className={textClasses}>
        <span className='text-[#fccb15]'>
          {totalPages === 0 ? 0 : page + 1}
        </span>{' '}
        / {totalPages}
      </strong>
      <button
        onClick={handleNextPage}
        disabled={page === totalPages - 1 || totalPages === 0}
        className={buttonBaseClasses}
      >
        {'>'}
      </button>
      <button
        onClick={handleLastPage}
        disabled={page === totalPages - 1 || totalPages === 0}
        className={buttonBaseClasses}
      >
        {'>>'}
      </button>
    </div>
  );
};

export default Pagination;
